import axios from "axios";
import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class AdminMediaService extends BaseService {
    static async list(params = {}) {
        const res = await this.get(`/media`, params, "ADMIN");
        return unwrapResponse(res);
    }
    static async upload(formData) {
        const res = await this.post(`/media`, formData, "ADMIN");
        return unwrapResponse(res);
    }
    static async remove(id) {
        const res = await axios.delete(BaseService.getUrl(`/media/${id}`, "ADMIN"));
        return unwrapResponse(res);
    }
}
